/**
 * @generated SignedSource<<eabd7da1128ee7c982fdad2d2867193c>>
 * @relayHash 926662064c00c0d51b6996cff2e49869
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 926662064c00c0d51b6996cff2e49869

import { ConcreteRequest } from 'relay-runtime';
export type Ch_updateCareProviderPermanentlyCloseInput = {
  careProviderId: string;
};
export type useCloseCareProviderPermanentlyMutation$variables = {
  input: Ch_updateCareProviderPermanentlyCloseInput;
};
export type useCloseCareProviderPermanentlyMutation$data = {
  readonly ch_updateCareProviderPermanentlyClose: {
    readonly careProvider: {
      readonly id: string;
    } | null;
  };
};
export type useCloseCareProviderPermanentlyMutation = {
  response: useCloseCareProviderPermanentlyMutation$data;
  variables: useCloseCareProviderPermanentlyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_updateCareProviderPermanentlyClosePayload",
    "kind": "LinkedField",
    "name": "ch_updateCareProviderPermanentlyClose",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareProvider",
        "kind": "LinkedField",
        "name": "careProvider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCloseCareProviderPermanentlyMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCloseCareProviderPermanentlyMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "926662064c00c0d51b6996cff2e49869",
    "metadata": {},
    "name": "useCloseCareProviderPermanentlyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8682ae7f487c036c82731fe04f6663a9";

export default node;
